import SimpleBillingScreen from './SimpleBillingScreen'
export default SimpleBillingScreen
